import classNames from 'classnames';

import * as api from '../../api';
import { Button } from '../../components/Button';
import { AppointmentsConfirmationCard } from './AppointmentConfirmationCard';

import defaultStyles from '../../styles/formSetStyles.module.css';
import styles from './index.module.css';
import { Trans, useTranslation } from 'react-i18next';

interface Props {
  appointmentsConfirmed?: api.NotificationIntent.Appointment[];
  onConfirmed?: () => void;
}

/**
 * Display information of all confirmed appointments.
 * Canceled and Rescheduled appointments are not shown as email confirmations are sent instead.
 */
export const AppointmentsConfirmationView: React.FC<Props> = ({
  appointmentsConfirmed,
  onConfirmed,
}) => {
  const { t } = useTranslation();
  const appointmentsConfirmedCount = appointmentsConfirmed?.length;
  const hasInstruction = !!appointmentsConfirmed?.find(
    (appointment) => appointment.encounter.patientInstructions,
  );
  const retrieveActionText = () => {
    if (appointmentsConfirmedCount === 0) {
      return t('Thank you for your response. No further action is needed.');
    }
    if (hasInstruction) {
      return t(
        'Review the following visit instructions to finish confirming your appointments:',
      );
    }
    return (
      <Trans
        i18nKey="thankYouWeLookForward"
        count={appointmentsConfirmedCount}
      />
    );
  };
  return (
    <>
      <div className={classNames(defaultStyles.Label, styles.Label)}>
        {retrieveActionText()}
      </div>
      {appointmentsConfirmed?.map((appointment, index) => {
        return (
          <AppointmentsConfirmationCard
            key={appointment.encounter.id}
            index={index}
            appointment={appointment}
          />
        );
      })}
      {appointmentsConfirmed &&
        appointmentsConfirmed.length > 0 &&
        onConfirmed && (
          <>
            <div
              className={classNames(
                defaultStyles.Label,
                styles.Label,
                styles.MarginTop2,
              )}
            >
              {t('Save time later by completing your registration now')}
            </div>
            <div>
              <Trans
                i18nKey="reviewYourVisitForms"
                count={appointmentsConfirmedCount}
              />
            </div>
            <Button
              type="button"
              onClick={onConfirmed}
              children={t('Complete my registration')}
              className={styles.ActionButton}
            />
          </>
        )}
    </>
  );
};
